export default __webpack_public_path__ + "static/media/Brawler's Cloak.3b91fd52.jpg";